{
  "title": "أوامر الخدمة",
  "changedMeanwhile": "غيّر شخص آخر هذا في الأثناء. حُمّلت أحدث نسخة: راجعها وحاول مرة أخرى.",
  "changedMeanwhileEdit": "غيّر شخص آخر هذا في الأثناء. حمّل أحدث نسخة لترى تغييره، ثم أدخل تغييرك من جديد.",
  "loadLatest": "تحميل أحدث نسخة",
  "fieldInvalid": "تحقّق من هذه القيمة.",
  "stage": {
    "AWAITING_VISIT": "بانتظار زيارة",
    "SCHEDULED": "مجدول",
    "IN_PROGRESS": "قيد التنفيذ",
    "NEEDS_VISIT": "يحتاج زيارة أخرى",
    "TO_INVOICE": "جاهز للفوترة",
    "AWAITING_PAYMENT": "بانتظار الدفع",
    "DONE": "مكتمل",
    "CANCELLED": "ملغى"
  },
  "status": {
    "NEW": "بانتظار زيارة",
    "SCHEDULED": "مجدول",
    "IN_PROGRESS": "قيد التنفيذ",
    "PARTIALLY_COMPLETED": "منجز جزئياً",
    "COMPLETED": "منجز",
    "CANCELLED": "ملغى"
  },
  "visitStatus": {
    "SCHEDULED": "مجدولة",
    "ON_SITE": "في الموقع",
    "IN_PROGRESS": "العمل جارٍ",
    "FINISHED": "منتهية",
    "CANCELLED": "ملغاة"
  },
  "outcome": {
    "FULL": "أُنجز بالكامل",
    "PARTIAL": "أُنجز جزئياً",
    "NONE": "لم يُنجز عمل"
  },
  "kind": {
    "INITIAL": "الزيارة الأولى",
    "FOLLOW_UP": "زيارة متابعة",
    "PLANNED": "زيارة وقائية",
    "plannedPart": "زيارة وقائية، الجزء {{n}}"
  },
  "billing": {
    "NOT_READY": "غير جاهز",
    "READY": "جاهز للفوترة",
    "PARTIALLY_INVOICED": "مفوتر جزئياً",
    "FULLY_INVOICED": "مفوتر بالكامل",
    "NO_VISIT_INVOICE": "ضمن عقد"
  },
  "payment": {
    "NONE": "لا فواتير",
    "UNPAID": "غير مدفوع",
    "PARTIALLY_PAID": "مدفوع جزئياً",
    "PAID": "مدفوع"
  },
  "money": {
    "invoiced": "مفوتر · {{payment}}",
    "partInvoiced": "مفوتر جزئياً · {{payment}}"
  },
  "priceApproval": {
    "NOT_REQUESTED": "السعر غير متفق عليه",
    "AWAITING": "بانتظار العميل",
    "ACCEPTED": "السعر متفق عليه",
    "CHANGED": "تعديلات تحتاج موافقة",
    "DECLINED": "رفض العميل السعر"
  },
  "agreementStatus": {
    "AWAITING": "بالانتظار",
    "ACCEPTED": "مقبولة",
    "DECLINED": "مرفوضة",
    "SUPERSEDED": "مستبدلة"
  },
  "agreementMethod": {
    "ON_SITE_SIGNED": "توقيع في الموقع",
    "ON_SITE_VERBAL": "موافقة شفهية في الموقع",
    "PHONE": "عبر الهاتف",
    "MESSAGE": "عبر واتساب أو رسالة",
    "EMAIL": "عبر البريد الإلكتروني"
  },
  "followUpStatus": {
    "PENDING": "بانتظار الموافقة",
    "APPROVED": "معتمد",
    "RETURNED": "مُعاد",
    "WITHDRAWN": "مسحوب"
  },
  "followUpReason": {
    "PARTS_NEEDED": "الحاجة إلى قطع",
    "MORE_TIME": "الحاجة إلى وقت إضافي",
    "CUSTOMER_UNAVAILABLE": "العميل غير متاح",
    "ACCESS_PROBLEM": "تعذّر الوصول إلى الموقع",
    "OTHER": "سبب آخر"
  },
  "collectionStatus": {
    "REPORTED": "بانتظار التحقق",
    "VERIFIED": "تم التحقق",
    "REJECTED": "مرفوض"
  },
  "priority": {
    "URGENT": "عاجلة",
    "HIGH": "عالية",
    "NORMAL": "عادية",
    "LOW": "منخفضة"
  },
  "dayPart": {
    "ANY": "أي وقت",
    "MORNING": "صباحاً",
    "AFTERNOON": "بعد الظهر",
    "EVENING": "مساءً"
  },
  "billingMode": {
    "CHARGEABLE": "بمقابل",
    "CONTRACT": "ضمن عقد صيانة"
  },
  "waiting": {
    "PARTS": "بانتظار القطع",
    "CUSTOMER": "بانتظار العميل"
  },
  "indicators": {
    "overdue": "متأخر",
    "followUpPending": "طُلبت زيارة متابعة",
    "collectionsAwaiting_zero": "لا مبالغ للتحقق",
    "collectionsAwaiting_one": "مبلغ واحد للتحقق",
    "collectionsAwaiting_two": "مبلغان للتحقق",
    "collectionsAwaiting_few": "{{n}} مبالغ للتحقق",
    "collectionsAwaiting_many": "{{n}} مبلغاً للتحقق",
    "collectionsAwaiting_other": "{{n}} مبلغ للتحقق"
  },
  "window": {
    "anyTime": "أي وقت",
    "from": "من {{time}}"
  },
  "fields": {
    "number": "أمر الخدمة",
    "customer": "العميل",
    "site": "موقع الخدمة",
    "contact": "جهة الاتصال في الموقع",
    "contactName": "اسم جهة الاتصال",
    "contactPhone": "هاتف جهة الاتصال",
    "issue": "المشكلة المبلّغ عنها",
    "plannedVisit": "زيارة وقائية",
    "requestedService": "الخدمة المطلوبة",
    "priority": "الأولوية",
    "preferredDate": "التاريخ المفضل",
    "preferredDayPart": "الوقت المفضل",
    "targetDate": "الإنجاز قبل",
    "billingMode": "الفوترة",
    "contractReference": "مرجع العقد",
    "team": "الفريق",
    "lead": "قائد الزيارة",
    "date": "التاريخ",
    "startTime": "من",
    "endTime": "إلى",
    "duration": "المدة المتوقعة",
    "notes": "ملاحظات",
    "nextVisit": "الزيارة التالية",
    "visits": "الزيارات",
    "createdAt": "تاريخ الفتح",
    "item": "البند",
    "quantity": "الكمية",
    "unitPrice": "سعر الوحدة",
    "tax": "ضريبة القيمة المضافة",
    "total": "الإجمالي",
    "agreed": "متفق عليه",
    "done": "منجز",
    "invoiced": "مفوتر",
    "remaining": "متبقٍ",
    "chargeable": "بمقابل",
    "covered": "مشمول بالعقد",
    "amount": "المبلغ",
    "method": "طريقة الدفع",
    "collectedOn": "تاريخ التحصيل",
    "collectedBy": "حصّله",
    "reference": "المرجع",
    "invoice": "الفاتورة",
    "balance": "الرصيد",
    "receipt": "سند القبض",
    "reason": "السبب",
    "remainingWork": "العمل المتبقي",
    "proposedDate": "التاريخ المقترح",
    "preparation": "التجهيز (قطع وأدوات)",
    "approverName": "اسم العميل",
    "approverPhone": "هاتف العميل",
    "address": "العنوان",
    "area": "المنطقة",
    "directions": "الإرشادات",
    "mapUrl": "رابط الخريطة",
    "siteName": "اسم الموقع"
  },
  "report": {
    "workPerformed": "العمل المنجز",
    "findings": "الملاحظات الفنية",
    "condition": "حالة المعدات",
    "unresolved": "مشكلات لم تُحل",
    "recommendations": "التوصيات",
    "nextAction": "الإجراء التالي",
    "acknowledgedBy": "أقرّ بها"
  },
  "units": {
    "minutes_zero": "{{n}} دقيقة",
    "minutes_one": "دقيقة واحدة",
    "minutes_two": "دقيقتان",
    "minutes_few": "{{n}} دقائق",
    "minutes_many": "{{n}} دقيقة",
    "minutes_other": "{{n}} دقيقة",
    "hours": "{{h}} س {{m}} د"
  },
  "visitLabel": "الزيارة {{sequence}}",
  "salesOff": {
    "title": "المبيعات غير مفعّلة لشركتك",
    "job": "الفواتير وسندات القبض من مستندات المبيعات، لذا لا يمكن فوترة العمل المنجز في هذا الطلب ولا تسجيل المبالغ المحصّلة أو التحقق منها حتى تُفعَّل المبيعات من جديد. يبقى العمل مسجّلاً.",
    "visit": "لا يمكن فوترة العمل المنجز ولا تسجيل المبالغ المحصّلة حتى تُفعَّل المبيعات من جديد. يُحفظ كل ما تسجّله في هذه الزيارة.",
    "tile": "المبيعات غير مفعّلة"
  },
  "errors": {
    "JOB_CANCELLED": "أمر الخدمة ملغى.",
    "JOB_COMPLETED": "أمر الخدمة منجز.",
    "JOB_HAS_OPEN_VISIT": "الفريق في الموقع: أنهِ الزيارة أولاً.",
    "JOB_HAS_INVOICES": "لأمر الخدمة فواتير: لم يعد بالإمكان تغيير طريقة فوترته.",
    "JOB_HAS_UNBILLED_WORK": "يوجد عمل منجز لم يُفوتر بعد: فوتره أولاً، أو اجعل تلك البنود مشمولة (بلا مقابل).",
    "SITE_HAS_VISITS": "لأمر الخدمة زيارة في هذا الموقع: ألغِ الزيارة المجدولة أولاً؛ وبعد الزيارة يبقى الأمر في موقعه.",
    "VISIT_OVERLAP": "لدى الفريق أو قائد الزيارة زيارة أخرى في ذلك الوقت.",
    "VISIT_ATTENDED": "بدأ الفريق هذه الزيارة: لم يعد بالإمكان إعادة جدولتها أو إلغاؤها.",
    "VISIT_NOT_ATTENDED": "لم يبدأ الفريق هذه الزيارة بعد.",
    "VISIT_NOT_IN_PROGRESS": "ابدأ العمل قبل تسجيل ما أُنجز.",
    "VISIT_FINISHED": "انتهت هذه الزيارة وتبقى كما جرت.",
    "VISIT_CANCELLED": "هذه الزيارة ملغاة.",
    "NOT_TEAM_MEMBER": "لا يقوم بذلك إلا فريق الزيارة (أو مدير الخدمة).",
    "LEAD_NOT_IN_TEAM": "يجب أن يكون قائد الزيارة عضواً نشطاً في الفريق.",
    "TEAM_ARCHIVED": "هذا الفريق مؤرشف. اختر فريقاً آخر.",
    "PRICE_NOT_AGREED": "سجّل موافقة العميل على السعر أولاً.",
    "SCOPE_CHANGED": "تغيّرت البنود منذ عرض السعر. راجعها وحاول مرة أخرى.",
    "NOTHING_TO_AGREE": "أضف البنود بمقابل وأسعارها أولاً.",
    "AGREEMENT_DECIDED": "تم البت في موافقة السعر هذه.",
    "ITEM_INVOICED": "جزء من هذا البند مفوتر: يبقى سعره كما فوتر.",
    "ITEM_BELOW_DONE": "لا يمكن أن تقل الكمية عمّا أُنجز أو فوتر.",
    "QUANTITY_EXCEEDS_REMAINING": "هذا أكثر من المتبقي.",
    "NOTHING_TO_INVOICE": "لم يبقَ عمل منجز لفوترته.",
    "NOT_CHARGEABLE": "هذا البند مشمول بالعقد: لا يُفوتر.",
    "FOLLOW_UP_PENDING": "يوجد طلب متابعة مفتوح لهذا الأمر.",
    "FOLLOW_UP_REQUIRED": "سبقت زيارة هذا الأمر: الزيارة التالية تأتي من طلب متابعة معتمد.",
    "VISIT_HAS_WORK": "سُجّل عمل في هذه الزيارة: اختر «أُنجز جزئياً».",
    "FOLLOW_UP_DECIDED": "تم البت في هذا الطلب.",
    "REPORT_INCOMPLETE": "ينقص تقرير الزيارة ما تشترطه الشركة (صورة أو إقرار العميل).",
    "INVOICE_NOT_OF_JOB": "اختر إحدى فواتير هذا الأمر.",
    "INVOICE_NOT_POSTED": "هذه الفاتورة ملغاة.",
    "COLLECTION_EXCEEDS_BALANCE": "هذا أكثر من المتبقي على الفاتورة.",
    "COLLECTION_DECIDED": "تم البت في هذا التحصيل.",
    "RECEIPT_MISMATCH": "اختر سند قبض مرحّلاً لهذا العميل لا يثبت تحصيلاً آخر.",
    "RECEIPT_NOT_ALLOCATED": "اختر سند قبض مخصّصاً لفاتورة هذا التحصيل بما لا يقل عن المبلغ المحصّل.",
    "SALES_MODULE_OFF": "المبيعات غير مفعلة لشركتك: الفواتير وسندات القبض غير متاحة.",
    "SITE_NOT_OF_CUSTOMER": "اختر أحد مواقع خدمة هذا العميل."
  },
  "discard": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "سيضيع ما أدخلته هنا.",
    "confirm": "تجاهل التغييرات",
    "keep": "متابعة التعديل"
  },
  "origin": {
    "REQUEST": "طلب",
    "PLANNED": "وقائي"
  },
  "visitPlaces_zero": "لا أماكن",
  "visitPlaces_one": "مكان واحد",
  "visitPlaces_two": "مكانان",
  "visitPlaces_few": "{{n}} أماكن",
  "visitPlaces_many": "{{n}} مكاناً",
  "visitPlaces_other": "{{n}} مكان",
  "availability": {
    "nextDays": "الأيام القادمة لـ{{team}}",
    "earlier": "أيام سابقة",
    "later": "أيام لاحقة",
    "today": "اليوم",
    "free": "متاح",
    "visits_zero": "لا زيارات",
    "visits_one": "زيارة واحدة",
    "visits_two": "زيارتان",
    "visits_few": "{{n}} زيارات",
    "visits_many": "{{n}} زيارة",
    "visits_other": "{{n}} زيارة",
    "off": "يوم عطلة",
    "holidayShort": "عطلة رسمية",
    "holidayLabel": "عطلة رسمية: {{name}}",
    "holidayProvisional": "{{name}} (غير مؤكدة)",
    "loadFailed": "تعذّر تحميل زيارات الفريق.",
    "retry": "أعد المحاولة",
    "past": "هذا التاريخ قد مضى.",
    "offDay": "{{day}} ليس يوم عمل في الشركة.",
    "holiday": "عطلة رسمية: {{name}}",
    "noVisits": "لا زيارات أخرى.",
    "reasons": "أسباب شائعة",
    "reason": {
      "customer": "طلب العميل",
      "team": "الفريق غير متاح",
      "parts": "بانتظار قطع الغيار",
      "access": "تعذّر الوصول أو الطقس"
    },
    "reasonText": {
      "customer": "طلب العميل تغيير موعد الزيارة.",
      "team": "الفريق غير متاح في ذلك الموعد.",
      "parts": "بانتظار وصول قطع الغيار قبل الزيارة.",
      "access": "تعذّر الوصول إلى الموقع، أو منع الطقس العمل."
    }
  }
}
